module.exports = __webpack_public_path__ + "static/media/SVGMail.1b0eb230.svg";